<template>
  <div class="card-content">
    <form>
      <div class="columns is-multiline is-variable is-1-mobile">
        <!-- Empresa -->
        <div class="column is-full-mobile is-one-quarter-desktop">
          <div class="field">
            <div class="control">
              <label class="label">Empresa</label>
              <b-input
                v-model="filtro.razaoSocial"
                icon="card-bulleted-outline"
                placeholder="Digite a Empresa"
                name="empresa"
                class="is-fullwidth"
                @input="buscar"
              />
            </div>
          </div>
        </div>
        <!-- CNPJ -->
        <div class="column is-full-mobile is-one-quarter-desktop">
          <div class="field">
            <div class="control">
              <label class="label">CNPJ</label>
              <b-input
                v-model="filtro.cnpj"
                icon="card-bulleted-outline"
                placeholder="Digite o CNPJ"
                name="placa"
                v-mask="'##.###.###/####-##'"
                class="is-fullwidth"
                @input="buscar"
              />
            </div>
          </div>
        </div>
        <!-- Tipo Empresa -->
        <div class="column is-full-mobile is-one-quarter-desktop">
          <div class="field">
            <div class="control">
              <label class="label">Tipo empresa</label>
              <b-select
                v-model="filtro.tipo"
                placeholder="Selecione um tipo de empresa"
                class="is-fullwidth"
                expanded
                @input="buscar"
              >
                <option :value="null">Todos</option>
                <option value="CONTRATANTE">Contratante</option>
                <option value="CONTRATADA">Contratada</option>
                <option value="PATIO_TRIAGEM">Patio Triagem</option>
                <option value="TERMINAL">Terminal</option>
                <option value="TRANSPORTADORA">Transportadora</option>
              </b-select>
            </div>
          </div>
        </div>
      <!-- Status -->
        <div class="column is-full-mobile is-one-quarter-desktop">
          <div class="field">
            <div class="control">
              <label class="label">Status</label>
              <b-select
                v-model="filtro.status"
                placeholder="Selecione um status"
                class="is-fullwidth"
                expanded
                @input="buscar"
              >
                <option :value="null">Todos</option>
                <option value="ATIVO">Ativo</option>
                <option value="INATIVO">Inativo</option>
                <option value="PENDENTE">Pendente</option>
              </b-select>
            </div>
          </div>
        </div>
        </div>
    </form>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "FilterEnterprise",
  props: {
    initialFiltro: {
      type: Object,
      default: () => ({
        razaoSocial: null,
        cnpj: null,
        tipo: null,
        status: null,
      }),
    },
  },
  data() {
    return {
      filtro: {...this.initialFiltro },
    }
  },
  methods:{
    buscar(){
        console.log("Emit dentro de FilterEnterprise foi chamado agora!")
        this.$emit('filtrar', this.filtro);
    }
  }
});
</script>
